import React, { useState, useEffect } from "react";
import { useFormContext } from "./FormContext";
import { useRouter } from "next/router";
import enIN from "@/locales/partner-program/enIN";
import esMX from "@/locales/partner-program/enMX";
import enUS from "@/locales/partner-program/enUS";

const PartnerFormStep1 = ({ showStep1 }) => {
  const { state, dispatch } = useFormContext();
  const { formData } = state;
  const router = useRouter();
  const { locale } = router;
  const t =
    (locale === "es-mx" && esMX) ||
    (locale === "en-us" && enUS) ||
    (locale === "en-in" && enIN);

  const [name, setName] = useState(formData?.name || "");
  const [lastName, setLastName] = useState(formData?.lastName || "");
  const [email, setEmail] = useState(formData?.email || "");
  const [phone, setPhone] = useState(formData?.phone || "");
  const [company, setCompany] = useState(formData?.company || "");
  const [allFieldsError, setAllFieldsError] = useState(false);
  const [phoneErrorMsg, setPhoneErrorMsg] = useState("");
  const [emailErrorMsg, setEmailErrorMsg] = useState("");
  const [companyErrorMsg, setCompanyErrorMsg] = useState("");
  const [nameErrorMsg, setNameErrorMsg] = useState("");

  useEffect(() => {
    if (name && phone && email && company && !phoneErrorMsg) {
      setAllFieldsError(false);
    }
  }, [name, phone, email, company, phoneErrorMsg]);

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    setPhone(value);
    const regex = /^[0-9]{10}$/;
    if (!regex.test(value)) {
      setPhoneErrorMsg(t?.FormData.phoneMessage);
    } else {
      setPhoneErrorMsg("");
    }
  };

  const handleNameChange = (e) => {
    const value = e.target.value;
    setName(value);
    if (value) {
      setNameErrorMsg("");
    } else {
      setNameErrorMsg(t?.FormData.requiredMessage);
    }
  };
  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setEmailErrorMsg("");

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (value && !emailRegex.test(value)) {
      setEmailErrorMsg(t?.FormData.emailMessage);
    }
  };

  const handleCompanyChange = (e) => {
    const value = e.target.value;
    setCompany(value);
    if (value) {
      setCompanyErrorMsg("");
    } else {
      setCompanyErrorMsg(t?.FormData.requiredMessage);
    }
  };

  // Handle form submission and validation
  const handleNext = () => {
    if (name && email && company && !phoneErrorMsg) {
      setAllFieldsError(false);
      showStep1(true);
      dispatch({
        type: "UPDATE_FORM_DATA",
        payload: { name, lastName, email, company, phone },
      });
      dispatch({
        type: "NEXT_STEP",
        payload: { name, lastName, email, company, phone },
      });
    } else {
      setAllFieldsError(true);
    }
  };

  const floatingLabelClass = `
  absolute left-1 top-[-8px] text-xs text-black font-normal bg-white px-1
  transition-all
  peer-placeholder-shown:top-2
  peer-placeholder-shown:text-sm
  peer-placeholder-shown:text-gray-400
  peer-focus:top-[-8px]
  peer-focus:text-xs
  peer-focus:text-[#555]
`;

  return (
    <div className="w-full">
      <form>
          <div className="mt-3 relative">
          <input
            name="Name"
            type="text"
            id="name"
            placeholder=''
            className="peer block w-full rounded-md border border-bordercolor p-2 text-sm text-secondary focus:border-[#288BED] focus:ring-[#555] focus:outline-none"
            value={name}
            onChange={handleNameChange}
          />
           <label htmlFor="name" className={floatingLabelClass}>
          {t.FormData.name}
          </label>
          {nameErrorMsg && (
            <p className="text-progressColor4 text-xs mt-0.5">
              {t.FormData.requiredMessage}
            </p>
          )}
        </div>
        <div className="mt-2 relative">
          <input
            name="lastName"
            type="text"
            id="lastName"
            placeholder=''
            className="peer block w-full rounded-md border border-bordercolor p-2 text-sm text-secondary focus:border-[#288BED] focus:ring-[#555] focus:outline-none"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
           <label htmlFor="lastName" className={floatingLabelClass}>
          {t.FormData.lastName}
          </label>
        </div>
        <div className="mt-2 relative">
          <input
            value={email}
            id="email"
            type="email"
            placeholder=''
            onChange={handleEmailChange}
            className="peer block w-full rounded-md border border-bordercolor p-2 text-sm text-secondary focus:border-[#288BED] focus:ring-[#555] focus:outline-none"
          />
           <label htmlFor="email" className={floatingLabelClass}>
          {t.FormData.Email}
          </label>
          {emailErrorMsg && (
            <p className="text-progressColor4 text-xs mt-0.5">
              {t.FormData.emailMessage}
            </p>
          )}
        </div>
        <div className="mt-2 relative">
          <input
            placeholder=''
            className="peer block w-full rounded-md border border-bordercolor p-2 text-sm text-secondary focus:border-[#288BED] focus:ring-[#555] focus:outline-none"
            value={phone}
            id="tel"
            type="tel"
            maxLength="10"
            onChange={handlePhoneChange}
          />
           <label htmlFor="tel" className={floatingLabelClass}>
          {t.FormData.Mobile}
          </label>
          {phoneErrorMsg && (
            <p className="text-red-500 text-xs mt-0.5">
              {t.FormData.phoneMessage}
            </p>
          )}
        </div>
        <div className="mt-2 relative">
          <input
            name="Company"
            type="text"
            id="company"
            onChange={handleCompanyChange}
            placeholder=''
            className="peer block w-full rounded-md border border-bordercolor p-2 text-sm text-secondary focus:border-[#288BED] focus:ring-[#555] focus:outline-none"
            value={company}
          />
          <label htmlFor="company" className={floatingLabelClass}>
          {t.FormData.Company}
          </label>
          {companyErrorMsg && (
            <p className="text-progressColor4 text-xs mt-0.5">
              {t.FormData.requiredMessage}
            </p>
          )}
        </div>

        <div className="mt-2">
          <button
            onClick={handleNext}
            className="py-1 px-3 rounded-md text-white text-base2  font-normal w-full bg-gradient-to-r from-[#022B5C] to-[#0363C4] shadow-lg transition-all duration-300 hover:from-[#0363C4] hover:to-[#022B5C] flex gap-x-1 justify-center items-center"
            type="button"
          >
            {t.FormData.nextBtn}
            <svg
              xmlns="https://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="brand"
              width="24"
              height="24"
              className="fill-current text-white"
            >
              <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path>
            </svg>
          </button>
        </div>
      </form>
      {allFieldsError && (
        <p className="text-red-500 text-xs mt-1">{t.FormData.allErrorMsg}</p>
      )}
    </div>
  );
};

export default PartnerFormStep1;
